import clsx from "clsx";
import style from "./P.module.css";

function P(props) {
  const {
    weight,
    font,
    size,
    i,
    min,
    max,
    marginBottom,
    color,
    fontStyle,
    textDecoration,
    textAlign,
    selected, // 선택 상태 유지 여부
    enableHover, // hover 기능 사용 여부
    textHover,
  } = props;

  let fontSize = size || props.fontSize;
  if (min) {
    fontSize = `max(${fontSize}, ${min})`;
  }
  if (max) {
    fontSize = `min(${fontSize}, ${max})`;
  }

  return (
    <p
      id={props.id}
      ref={props.Ref}
      className={clsx(
        style.paragraph,
        { [style.ellipsis]: props.ellipsis === true },
        { [style.selected]: selected === true },
        { [style.hoverEnabled]: enableHover === true && !selected },
        { [style.textHover]: textHover === true },
        
        props.className,
        "notranslate"
      )}
      style={{
        width: props.width ? props.width : null,
        minWidth: props.minWidth ? props.minWidth : null,
        fontWeight: weight || props.fontWeight,
        fontFamily: font || props.fontFamily,
        fontSize: fontSize,
        fontStyle: i ? "italic" : fontStyle ? fontStyle : "normal",
        marginBottom: marginBottom,
        textIndent: props.textIndent ? props.textIndent : null,
        color: color ? color : "inherit",
        textDecoration: textDecoration ? textDecoration : null,
        verticalAlign: props.verticalAlign ? props.verticalAlign : "middle",
        whiteSpace: props.whiteSpace ? props.whiteSpace : null,
        textAlign: textAlign ? textAlign : null,
        padding: props.padding ? props.padding : null,
        margin: props.margin ? props.margin : null,
        marginLeft: props.marginLeft ? props.marginLeft : null,
        backgroundColor: props.backgroundColor ? props.backgroundColor : null,
        border: props.border ? props.border : null,
        borderRadius: props.borderRadius ? props.borderRadius : null,
        cursor: props.cursor ? "pointer" : "inherit",
        lineHeight: props.lineHeight ? props.lineHeight : null,
        height: props.height ? props.height : null,
        letterSpacing: props.letterSpacing ? props.letterSpacing : null,
        wordBreak: props.wordBreak ? props.wordBreak : null,
        overflow: props.overflow ? props.overflow : null,
        textOverflow: props.textOverflow ? props.textOverflow : null,
        ...props.style,
      }}
      onClick={props.onClick}
      onMouseDown={props.onMouseDown}
    >
      {props.children}
    </p>
  );
}

export default P;
